module.exports = __webpack_public_path__ + "img/logo_golf_row_white.d3bf37ab.png";